import { format, formatToDayAndMonth } from "utils/datetime-format-utils"

interface FromToDataProps {
    from: Date
    to: Date
}

export function FromToData({ from, to }: FromToDataProps) {
    const sameMonth = format(from, "MMMM") === format(to, "MMMM")

    return (
        <div className="date-picker__week__short">
            {sameMonth ? format(from, "d") : formatToDayAndMonth(from)}
            &mdash;
            {formatToDayAndMonth(to)}
        </div>
    )
}
